import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  min-height: 23rem;
  padding: 3rem 5rem;
  width: 72.4rem;
  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 1000;
    margin-bottom: 0;
    text-align: center;
  }
`;

export const TextContainer = styled.div`
  margin-top: 3.2rem;
  h3 {
    color: rgba(46, 53, 61, 0.3);
    font-size: 12px;
    font-weight: bold;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

interface IButton {
  disabled?: any;
}
export const Button = styled.button<IButton>`
  ${(props) => `
    background-color: ${
      props.disabled
        ? props.theme.colors.accentGreen + props.theme.transparencies.p30
        : props.theme.colors.accentGreen
    };
    color: ${props.theme.colors.white};
    font-family: ${props.theme.fontFamilies.primaryFont};
    cursor: ${props.disabled ? "not-allowed" : "pointer"};
  `}
  align-items: center;
  border-radius: 8px;
  border: none;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  height: 5rem;
  justify-content: center;
  margin-top: 3rem;
  width: 32.4rem;
  .icon {
    height: 5rem;
    width: 5rem;
  }
`;

export const TableContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  margin-top: 2.5rem;
  border-radius: 10px;
`;

export const RowContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  display: grid;
  gap: 1rem;
  font-size: 1.2rem;
  grid-template-columns: 12rem 1fr;

  div:first-child {
    font-weight: 700;
  }
`;
